var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 147,
    viewBox: "0 0 147 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9314 129.28C36.614 137.248 48.1927 142.576 60.5429 144.748C72.893 146.919 85.5949 145.86 97.4147 141.673C109.235 137.485 119.771 130.313 128 120.851C136.229 111.389 141.871 99.9598 144.378 87.6734C146.885 75.3871 146.173 62.6611 142.309 50.7315C138.446 38.8019 131.562 28.0743 122.328 19.5904C113.094 11.1066 101.823 5.15506 89.6099 2.31376C77.3965 -0.527531 64.6558 -0.161963 52.6253 3.37496L53.0466 4.80782C64.8299 1.34354 77.3089 0.985484 89.2715 3.76842C101.234 6.55135 112.274 12.3807 121.318 20.6902C130.362 28.9998 137.104 39.5071 140.888 51.1917C144.672 62.8762 145.37 75.3408 142.915 87.3748C140.459 99.4088 134.933 110.603 126.873 119.871C118.813 129.138 108.493 136.164 96.916 140.265C85.3389 144.366 72.898 145.404 60.8015 143.277C48.705 141.15 37.3642 135.931 27.8804 128.127L26.9314 129.28Z",
    fill: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 128.5,
    r: 3.5,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI3);
export default __webpack_public_path__ + "static/media/i3.cd2c7a86ab1dd73768abe406c247684e.svg";
export { ForwardRef as ReactComponent };